import { Card } from 'antd';

import Container from '../../components/Container';
import WxWorkChatUserTable from '../../components/wxwork/WxWorkChatUserTable';

const WxWorkChatUserList = () => {
  return (
    <Container>
      <Card>
        <WxWorkChatUserTable />
      </Card>
    </Container>
  );
};

export default WxWorkChatUserList;
